export const mockRestaurantSales = [
  {
    id: "r1",
    payment_method: "nakit",
    total_amount: 450.00,
    created_at: "2025-02-18T13:45:00+03:00",
    room_number: "101",
    customer_name: "Ahmet Yılmaz",
    sale_type: "restaurant",
    staff_id: "s1",
    collected_by_staff_id: null,
    collected_at: null,
    payment_status: "completed",
    sale_items: [
      { product_id: "p1", quantity: 2, unit_price: 150, description: "Izgara Köfte" },
      { product_id: "p2", quantity: 2, unit_price: 75, description: "Ayran" },
    ],
  },
  {
    id: "r2",
    payment_method: "kredi_karti",
    total_amount: 780.00,
    created_at: "2025-02-18T14:10:00+03:00",
    room_number: "102",
    customer_name: "Mehmet Demir",
    sale_type: "restaurant",
    staff_id: "s2",
    collected_by_staff_id: null,
    collected_at: null,
    payment_status: "completed",
    sale_items: [
      { product_id: "p3", quantity: 1, unit_price: 320, description: "Karışık Izgara Tabağı" },
      { product_id: "p4", quantity: 2, unit_price: 180, description: "Mevsim Salata" },
      { product_id: "p5", quantity: 2, unit_price: 50, description: "Kola" },
    ],
  },
  {
    id: "r3",
    payment_method: "oda_hesabi",
    total_amount: 320.00,
    created_at: "2025-02-18T14:30:00+03:00",
    room_number: "203",
    customer_name: "Ayşe Kaya",
    sale_type: "restaurant",
    staff_id: "s3",
    collected_by_staff_id: null,
    collected_at: null,
    payment_status: "pending",
    sale_items: [
      { product_id: "p6", quantity: 1, unit_price: 220, description: "Tavuk Şinitzel" },
      { product_id: "p7", quantity: 2, unit_price: 50, description: "Çorba" },
    ],
  },
  {
    id: "r4",
    payment_method: "kismi_odeme",
    total_amount: 550.00,
    created_at: "2025-02-18T15:00:00+03:00",
    room_number: "105",
    customer_name: "Fatma Şahin",
    sale_type: "restaurant",
    staff_id: "s1",
    collected_by_staff_id: null,
    collected_at: null,
    payment_status: "pending",
    sale_items: [
      { product_id: "p8", quantity: 2, unit_price: 200, description: "Bonfile" },
      { product_id: "p9", quantity: 1, unit_price: 150, description: "Pide" },
    ],
  },
  {
    id: "r5",
    payment_method: "nakit",
    total_amount: 180.00,
    created_at: "2025-02-18T15:20:00+03:00",
    room_number: "108",
    customer_name: "Ali Çelik",
    sale_type: "restaurant",
    staff_id: "s4",
    collected_by_staff_id: null,
    collected_at: null,
    payment_status: "completed",
    sale_items: [
      { product_id: "p10", quantity: 3, unit_price: 60, description: "Lahmacun" },
    ],
  },
  {
    id: "r6",
    payment_method: "oda_hesabi",
    total_amount: 890.00,
    created_at: "2025-02-18T16:00:00+03:00",
    room_number: "301",
    customer_name: "Zeynep Öztürk",
    sale_type: "restaurant",
    staff_id: "s2",
    collected_by_staff_id: null,
    collected_at: null,
    payment_status: "pending",
    sale_items: [
      { product_id: "p11", quantity: 1, unit_price: 400, description: "Deniz Mahsulleri Tabağı" },
      { product_id: "p12", quantity: 1, unit_price: 290, description: "Kuzu Tandır" },
      { product_id: "p13", quantity: 2, unit_price: 100, description: "Sufle" },
    ],
  },
  {
    id: "r7",
    payment_method: "kredi_karti",
    total_amount: 420.00,
    created_at: "2025-02-18T16:45:00+03:00",
    room_number: "202",
    customer_name: "Mustafa Aydın",
    sale_type: "restaurant",
    staff_id: "s3",
    collected_by_staff_id: null,
    collected_at: null,
    payment_status: "completed",
    sale_items: [
      { product_id: "p14", quantity: 2, unit_price: 170, description: "Adana Kebap" },
      { product_id: "p15", quantity: 2, unit_price: 40, description: "Şalgam" },
    ],
  },
  {
    id: "r8",
    payment_method: "oda_hesabi",
    total_amount: 650.00,
    created_at: "2025-02-18T17:30:00+03:00",
    room_number: "104",
    customer_name: "Elif Yıldız",
    sale_type: "restaurant",
    staff_id: "s4",
    collected_by_staff_id: null,
    collected_at: null,
    payment_status: "pending",
    sale_items: [
      { product_id: "p16", quantity: 1, unit_price: 350, description: "Testi Kebabı" },
      { product_id: "p17", quantity: 1, unit_price: 200, description: "Meze Tabağı" },
      { product_id: "p18", quantity: 2, unit_price: 50, description: "Tatlı" },
    ],
  },
  {
    id: "r9",
    payment_method: "kismi_odeme",
    total_amount: 380.00,
    created_at: "2025-02-18T18:00:00+03:00",
    room_number: "205",
    customer_name: "Osman Karaca",
    sale_type: "restaurant",
    staff_id: "s2",
    collected_by_staff_id: null,
    collected_at: null,
    payment_status: "pending",
    sale_items: [
      { product_id: "p19", quantity: 1, unit_price: 260, description: "Balık Tava" },
      { product_id: "p20", quantity: 2, unit_price: 60, description: "İçecek" },
    ],
  },
  {
    id: "r10",
    payment_method: "nakit",
    total_amount: 220.00,
    created_at: "2025-02-18T18:30:00+03:00",
    room_number: "107",
    customer_name: "Hasan Polat",
    sale_type: "restaurant",
    staff_id: "s1",
    collected_by_staff_id: null,
    collected_at: null,
    payment_status: "completed",
    sale_items: [
      { product_id: "p21", quantity: 1, unit_price: 120, description: "Hamburger" },
      { product_id: "p22", quantity: 1, unit_price: 100, description: "Patates Kızartması" },
    ],
  },
];

export const mockRoomAccounts = [
  {
    id: "ra1",
    room_number: "203",
    customer_name: "Ayşe Kaya",
    total_amount: 320.00,
    created_at: "2025-02-18T14:30:00+03:00",
    payment_method: "oda_hesabi",
    status: "pending",
    sale_type: "restaurant",
  },
  {
    id: "ra2",
    room_number: "301",
    customer_name: "Zeynep Öztürk",
    total_amount: 890.00,
    created_at: "2025-02-18T16:00:00+03:00",
    payment_method: "oda_hesabi",
    status: "pending",
    sale_type: "restaurant",
  },
  {
    id: "ra3",
    room_number: "104",
    customer_name: "Elif Yıldız",
    total_amount: 650.00,
    created_at: "2025-02-18T17:30:00+03:00",
    payment_method: "oda_hesabi",
    status: "pending",
    sale_type: "restaurant",
  },
];